export const environment = {
  production: true,
  environmentName: 'production',
  tracesSampleRate: 0.3,
  configCatKey: 'Ag_ZCDm6FkSAA5-xhxheOA/ecD-M7KG3EGIJDdwsbwbPg',
  cmsUri: 'https://asc-wds-cms.directus.app',
  appRunnerEndpoint:''
};
